import { useNavigate } from 'react-router-dom'
import { ArrowUpRight } from 'lucide-react'

import CtaPill from '@/components/CtaPill'
import Tooltip from '@/components/Tooltip'

interface EnterpriseTagProps {
  tooltipText: string
}

const EnterpriseTag = ({ tooltipText }: EnterpriseTagProps) => {
  const navigate = useNavigate()

  return (
    <Tooltip text={tooltipText} placement="top" hideArrow>
      <CtaPill
        label="Enterprise"
        icon={<ArrowUpRight size={12} aria-hidden />}
        onClick={() => navigate('/app/settings/billing')}
      />
    </Tooltip>
  )
}

export default EnterpriseTag
